import { useQuery } from '@tanstack/react-query';
import { getMyComplianceStatus } from '../../../services/MoodleService';
import { moodleQueryKeys } from '../all-query-keys';

export const useGetMyComplianceStatus = ({ enabled = true } = {}) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: moodleQueryKeys.getComplianceStatus(),
    queryFn: () => getMyComplianceStatus(),
    enabled,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  const courses = data?.data || [];
  
  return {
    courses,
    loading: isLoading,
    refetch,
  };
};
